import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import NotFound from '../../not-found';
import Redirect from '../../redirect';
import Documents from './documents';
import EditFormMentee from './edit-form';
import MentorshipManagement from './management';
import ReviewPage from './management/interviews/[id]';
import MenteeMessaging from './messaging';
import SignChart from './sign-chart';

const MentorshipRoutes: FC = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<Redirect href="/mentee/mentorship/edit-form" />}
      />
      <Route path="/edit-form" element={<EditFormMentee />} />
      <Route path="/sign-chart" element={<SignChart />} />
      <Route path="/messaging/*" element={<MenteeMessaging />} />
      <Route path="/management/interviews/:id" element={<ReviewPage />} />
      <Route path="/management/*" element={<MentorshipManagement />} />
      <Route path="/documents" element={<Documents />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default MentorshipRoutes;
